import Vue from 'vue'
import Vuex from 'vuex'

import storePost from './store-post'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    storePost
  }
})
